/* Presentation adapter; the existing theme owns prices, variants and cart writes. */
(()=>{
  const boot=()=>{
    const main=document.querySelector('.c2f-historical-main');
    if(!main||main.dataset.c2fAdapted)return;
    main.dataset.c2fAdapted='true';
    const picker=main.querySelector('.c2f-historical-picker');
    const sizeOrder=['XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL','6XL'];
    picker?.querySelectorAll('fieldset').forEach(field=>{
      const list=field.querySelector('.c2f-historical-options'),items=[...list.children];
      const name=field.dataset.optionName.toLowerCase();
      if(items.every(el=>sizeOrder.includes(el.dataset.value.toUpperCase())))items.sort((a,b)=>sizeOrder.indexOf(a.dataset.value.toUpperCase())-sizeOrder.indexOf(b.dataset.value.toUpperCase()));
      else if(/capacit|mémoire|stockage/.test(name)&&items.every(el=>/^\d/.test(el.dataset.value)))items.sort((a,b)=>parseFloat(a.dataset.value)-parseFloat(b.dataset.value));
      else if(picker.querySelectorAll('fieldset').length===1&&/pack|configuration/.test(name))items.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
      items.forEach(el=>list.append(el));
    });
    const form=main.querySelector('product-form form');
    const final=document.querySelector('.c2f-historical-page .c2f-final-cta');
    const submit=form?.querySelector('[name="add"]');
    const sync=variant=>{
      if(!form||!final)return;
      const price=main.querySelector('.price__sale .price-item--sale')||main.querySelector('.price__regular .price-item');
      const amount=final.querySelector('[data-c2f-final-price]');
      if(price&&amount)amount.textContent=price.textContent.trim();
      const label=final.querySelector('[data-c2f-selected-label]');
      if(label&&picker)label.textContent=[...picker.querySelectorAll('input:checked')].map(x=>x.value).join(' · ');
      const buy=final.querySelector('[data-c2f-final-buy]');
      if(buy)buy.setAttribute('aria-disabled',String(!!submit?.disabled));
      if(variant)main.querySelector('c2f-delivery-module')?.setVariant?.(variant);
    };
    if(final){
      final.querySelector('[data-c2f-final-buy]')?.addEventListener('click',e=>{
        e.preventDefault();
        if(submit&&!submit.disabled){form.requestSubmit(submit)}
        else main.scrollIntoView({behavior:'smooth',block:'start'});
      });
      new MutationObserver(()=>sync()).observe(main.querySelector('[id^="price-"]'),{childList:true,subtree:true});
    }
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.variantChange,event=>{
      if(event.data.sectionId===main.dataset.section)sync(event.data.variant);
    });
    sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* Preserve source content/media; only arrange the ten approved descriptions. */
(()=>{
  const refine=()=>{
    const main=document.querySelector('.c2f-historical-main');
    if(!main)return;
    const picker=main.querySelector('.c2f-historical-picker');
    if(picker&&!picker.dataset.c2fPhotos){
      picker.dataset.c2fPhotos='true';
      const variants=JSON.parse(picker.querySelector('script[type="application/json"]')?.textContent||'[]');
      const fields=[...picker.querySelectorAll('fieldset')];
      const photos=()=>{
        const selected=fields.map(f=>f.querySelector('input:checked')?.value);
        fields.forEach((field,index)=>field.querySelectorAll('.c2f-historical-option').forEach(card=>{
          const candidate=variants.find(v=>v.options.every((value,i)=>value===(i===index?card.dataset.value:selected[i])))||variants.find(v=>v.options[index]===card.dataset.value);
          const image=card.querySelector('img');
          if(image&&candidate?.featured_image?.src){
            const src=new URL(candidate.featured_image.src,location.origin);src.searchParams.set('width','200');
            image.removeAttribute('srcset');image.src=src.href;
          }
        }));
      };
      picker.addEventListener('change',photos);photos();
    }
    if(main.dataset.c2fBest!=='true')return;
    const source=main.querySelector('.product__description--bottom');
    if(!source||source.dataset.c2fChapters)return;
    source.dataset.c2fChapters='true';
    // Flatten only editorial containers that contain headings; preserve all nodes.
    const flatten=node=>{
      if(node.nodeType===1&&node.tagName==='DIV'&&node.querySelector('h2,h3')&&!node.querySelector('form'))return [...node.childNodes].flatMap(flatten);
      return [node];
    };
    const nodes=[...source.childNodes].flatMap(flatten);
    const groups=[];let group=[];
    nodes.forEach(node=>{
      if(node.nodeType===1&&node.matches('h2,h3')&&group.some(n=>n.nodeType===1&&!n.matches('h2,h3')&&(n.textContent.trim()||n.matches('img,video,iframe')||n.querySelector('img,video,iframe')))){groups.push(group);group=[];}
      group.push(node);
    });if(group.length)groups.push(group);
    let visualIndex=0;
    const result=document.createDocumentFragment();
    groups.forEach(items=>{
      if(!items.some(n=>n.textContent.trim()||(n.nodeType===1&&n.querySelector('img,video,iframe')))){items.forEach(n=>result.append(n));return;}
      const article=document.createElement('article');article.className='c2f-legacy-chapter';
      const media=document.createElement('div');media.className='c2f-legacy-media';
      const copy=document.createElement('div');copy.className='c2f-legacy-copy';
      items.forEach(node=>{
        const pureMedia=node.nodeType===1&&(node.matches('img,video,iframe')||node.querySelector('img,video,iframe'))&&!node.textContent.trim()&&!node.querySelector('table');
        (pureMedia?media:copy).append(node);
      });
      if(media.childNodes.length){
        article.classList.add('c2f-legacy-chapter--'+(visualIndex%2===0?'right':'left'));
        article.classList.add('c2f-legacy-chapter--'+['light','dark','sand'][visualIndex%3]);visualIndex++;
        article.append(media,copy);
      }else{article.classList.add('c2f-legacy-chapter--text');article.append(copy);}
      if(article.querySelector('table'))article.classList.add('c2f-legacy-chapter--table');
      result.append(article);
    });
    source.replaceChildren(result);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refine);else refine();
  document.addEventListener('shopify:section:load',refine);
})();
